import { useEffect, useState } from "react";
import {
  getDashboardSumission,
  getGroupByData,
} from "src/utils/helper/functions";
import MapChart from "./map-chart.component";

type AssetsByCountryProps = {
  assets: any;
};

const AssetsByCountry: React.FC<AssetsByCountryProps> = ({
  assets,
}: AssetsByCountryProps) => {
  const [assetsAllocationData, setAssetsAllocationData] = useState<any[]>([]);

  useEffect(() => {
    prepareData();
  }, [assets]);

  const prepareData = () => {
    const groupedData = getGroupByData(assets, "countryGroupName");
    const values: any = [];

    setAssetsAllocationData(
      Object.entries(groupedData)?.map(([key, value]: any) => {
        const summission = (
          (getDashboardSumission(value, "totalPercentageFromPortfolio") /
            getDashboardSumission(assets, "totalPercentageFromPortfolio")) *
          100
        )?.toFixed(1);
        values.push(summission);
        return {
          label: key,
          value: summission,
        };
      })
    );
  };

  return (
    <div className="w-full slide-bottom p-4 bg-white rounded-xl add-shadow border border-[#e3e3e3] flex-col justify-start items-center gap-5 inline-flex">
      <div className=" self-stretch justify-between items-center inline-flex">
        <div className=" opacity-90 text-[#2a2a2a] text-sm md:text-base font-bold ">
          {" "}
          Assets by Country
        </div>
      </div>
      <div className=" flex grow justify-center items-center ">
        {assetsAllocationData?.length ? (
          <MapChart assetsAllocationData={assetsAllocationData} />
        ) : (
          <div className="flex flex-col grow justify-center items-center h-full">
            <img
              src={"/images/empty-portfolio.svg"}
              width={40}
              height={40}
              alt="Empty Performance Icon"
            />
            <p className="text-neutral-400 text-sm mt-3">
              You have no assets yet
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssetsByCountry;
